import SEO from './SEO';

export default SEO;
export * from './SEO';
